<template>
  <div
    class="bg-card"
  >
    <div class="row m-0 py-2 px-4">
      <img
        v-if="!currentOffer.companyHideName"
        class="company-logo mr-4"
        :src="basepath + 'uploads/company_logos/' + currentOffer.user.company.avatar.filename"
      >
      <img
        v-else
        class="company-logo m-4"
        :src="basepath + 'uploads/company_logos/no_logo.png'"
      >
      <div class="my-auto">
        <h1 class="mb-0">
          {{ currentOffer.titleTitle }}
        </h1>
        <h3 class="--hover text-uppercase m-0 --green">
          <span v-if="currentOffer.companyHideName === 0">
            <span
              class="real-title"
              @click="$router.push({ path: '/jobs/company/' + currentOffer.user.company.id + '/' + generateSlug })"
            >
              {{ currentOffer.user.company.title }}
            </span>
          </span>
          <span
            v-if="currentOffer.companyHideName === 1"
            style="font-size: 0.85rem;"
          >
            {{ $t('generic.hidden-company-name', 'Company name not available') }}
          </span>
        </h3>
        <span
          v-if="isNew"
          class="new-offer"
        >{{ $t('generic.new', 'New') }}</span>
      </div>
    </div>
    <div class="row facts">
      <div class="col-12 col-sm-6">
        <ul>
          <li>
            {{ currentOffer.locationProvince }},
            {{ currentOffer.locationMunicipality }}
            ({{ currentOffer.locationCountry }})
          </li>
          <li>{{ $t('pages.one-offer.published', 'Published') }} {{ currentOffer.created_at }}</li>
          <li>
            <div>
              <span v-if="currentOffer.salaryShowAs === 'from-to'">
                {{
                  $t(
                    'pages.one-offer.salary-from-to', '{min} - {max} {type}',
                    {
                      min: currentOffer.salaryMinimum,
                      max: currentOffer.salaryMaximum,
                      type: $t(`data.salaryTypes.${currentOffer.salaryType}`, currentOffer.salaryType)
                    }
                  )
                }}
              </span>
              <span v-else-if="currentOffer.salaryShowAs === 'more-than'">
                {{
                  $t(
                    'pages.one-offer.salary-more-than', 'More than {min} {type}',
                    {
                      min: currentOffer.salaryMinimum,
                      type: $t(`data.salaryTypes.${currentOffer.salaryType}`, currentOffer.salaryType)
                    }
                  )
                }}
              </span>
              <span v-else-if="currentOffer.salaryShowAs === 'dont-show'">
                {{ $t('pages.one-offer.salary-dont-show', 'Salary not available') }}
              </span>
            </div>
          </li>
        </ul>
      </div>
      <div class="col-12 col-sm-6">
        <ul>
          <li>
            {{ $t('pages.one-offer.minimum-experience', 'Minimum experience') }}: {{ $t(`data.experience.${currentOffer.requirementsMinExp}`, currentOffer.requirementsMinExp) }}
          </li>
          <li>
            {{ $t('pages.one-offer.contract-type', 'Type of contract') }}: {{ $t(`data.contractTypes.${currentOffer.contractType}`, currentOffer.contractType) }}
          </li>
        </ul>
      </div>
      <div class="col mt-2">
        <b-button
          v-if="
            !currentOffer.isArchived
              && (currentOffer.isApplied === false || !currentOffer.isApplied)
              && (this.$hasRole(['candidate']) || !this.$auth.check())
          "
          variant="info"
          class="apply-button"
          @click="$emit('offerApply')"
        >
          {{ $t('pages.one-offer.apply-to-this-offer', 'Apply to this offer') }}
        </b-button>
        <b-button
          v-if="
            !currentOffer.isArchived
              && (currentOffer.isApplied === true && currentOffer.isApplied != null)
              && this.$hasRole(['candidate'])
          "
          variant="info"
          class="apply-button"
          disabled
          style="background: green; border-color: green;"
        >
          {{ $t('pages.one-offer.already-enrolled', 'Already enrolled') }}
        </b-button>
        <b-button
          v-else-if="currentOffer.isArchived && this.$auth.check() && !this.$hasRole(['candidate']) "
          variant="info"
          class="apply-button"
          disabled
          style="background: orange; border-color: orange;"
        >
          {{ $t('pages.one-offer.archived', 'Archived') }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentOffer: {
      type: Object,
      default: null
    }
  },
  computed: {
    isNew() {
      let OneDay = new Date().getTime() - (24 * 60 * 60 * 1000);
      let offerDate = new Date(this.currentOffer.created_at);
        if (OneDay < offerDate) {
          return true;
        } else {
          return false;
        }
    },
    basepath() {
      return process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PUBLIC_PATH;
    }
  },
}
</script>

<style lang="scss" scoped>
  .facts {
    ul {
      margin: 0;

      li {
        font-size: 0.9rem !important;
        padding: unset;
      }
    }
  }

  .apply-button {
    font-size: 0.9rem;
    font-weight: 600;
    background: #ff6340;
    border: 1px solid #ff6340;
    text-transform: uppercase;

    &:hover {
      background: #ff4e27;
    }
  }

  .company-logo {
    width: 100px;
    height: 100px;
    border-radius: 5px;
    border: 1px solid #efefef;
    box-shadow: 2px 3px 15px 10px rgba(0, 0, 0, 0.1), -1px 0 2px 0px rgba(0, 0, 0, 0.05);
  }

  .new-offer {
    margin-left: 0.5rem;
    background: #00a550;
    color: white;
    font-size: 0.75rem;
    padding: 2px 3px;
    border-radius: 3px;
  }
</style>
